import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'
import {ICampaign} from './getCampaign'

export type campaignsType = 'all' | 'open' | 'close'

export const getCampaigns = async (status: campaignsType = 'all'): Promise<ApiRes<ICampaign[]>> => {
    return await apiGet(API_URL, `campaigns?status=${status}`)
}
